// utils
import { paramCase } from 'src/utils/change-case';
import { _id, _postTitles } from 'src/_mock/assets';

// ----------------------------------------------------------------------

const MOCK_ID = _id[1];

const MOCK_TITLE = _postTitles[2];

const ROOTS = {
  AUTH: '/auth',
  AUTH_DEMO: '/auth-demo',
  DASHBOARD: '/dashboard',
};

// ----------------------------------------------------------------------

export const paths = {
  comingSoon: '/coming-soon',
  maintenance: '/maintenance',
  pricing: '/pricing',
  payment: '/payment',
  about: '/about-us',
  contact: '/contact-us',
  faqs: '/faqs',
  page403: '/403',
  page404: '/404',
  page500: '/500',
  components: '/components',
  docs: 'https://docs.minimals.cc',
  changelog: 'https://docs.minimals.cc/changelog',
  zoneUI: 'https://mui.com/store/items/zone-landing-page/',
  minimalUI: 'https://mui.com/store/items/minimal-dashboard/',
  freeUI: 'https://mui.com/store/items/minimal-dashboard-free/',
  figma:
    'https://www.figma.com/file/kAYnYYdib0aQPNKZpgJT6J/%5BPreview%5D-Minimal-Web.v5.0.0?type=design&node-id=0%3A1&t=Al4jScQq97Aly0Mn-1',
  product: {
    root: `/product`,
    checkout: `/product/checkout`,
    details: (id) => `/product/${id}`,
    demo: {
      details: `/product/${MOCK_ID}`,
    },
  },
  post: {
    root: `/post`,
    details: (title) => `/post/${paramCase(title)}`,
    demo: {
      details: `/post/${paramCase(MOCK_TITLE)}`,
    },
  },
  // AUTH
  auth: {
    amplify: {
      login: `${ROOTS.AUTH}/amplify/login`,
      verify: `${ROOTS.AUTH}/amplify/verify`,
      register: `${ROOTS.AUTH}/amplify/register`,
      newPassword: `${ROOTS.AUTH}/amplify/new-password`,
      forgotPassword: `${ROOTS.AUTH}/amplify/forgot-password`,
    },
    jwt: {
      login: `${ROOTS.AUTH}/jwt/login`,
      register: `${ROOTS.AUTH}/jwt/register`,
    },
    firebase: {
      login: `${ROOTS.AUTH}/firebase/login`,
      verify: `${ROOTS.AUTH}/firebase/verify`,
      register: `${ROOTS.AUTH}/firebase/register`,
      forgotPassword: `${ROOTS.AUTH}/firebase/forgot-password`,
    },
    auth0: {
      login: `${ROOTS.AUTH}/auth0/login`,
    },
    cms: {
      login: `${ROOTS.AUTH}/cms/login`
    },
  },
  authDemo: {
    classic: {
      login: `${ROOTS.AUTH_DEMO}/classic/login`,
      register: `${ROOTS.AUTH_DEMO}/classic/register`,
      forgotPassword: `${ROOTS.AUTH_DEMO}/classic/forgot-password`,
      newPassword: `${ROOTS.AUTH_DEMO}/classic/new-password`,
      verify: `${ROOTS.AUTH_DEMO}/classic/verify`,
    },
    modern: {
      login: `${ROOTS.AUTH_DEMO}/modern/login`,
      register: `${ROOTS.AUTH_DEMO}/modern/register`,
      forgotPassword: `${ROOTS.AUTH_DEMO}/modern/forgot-password`,
      newPassword: `${ROOTS.AUTH_DEMO}/modern/new-password`,
      verify: `${ROOTS.AUTH_DEMO}/modern/verify`,
    },
  },
  // DASHBOARD
  dashboard: {
    root: ROOTS.DASHBOARD,
    mail: `${ROOTS.DASHBOARD}/mail`,
    chat: `${ROOTS.DASHBOARD}/chat`,
    blank: `${ROOTS.DASHBOARD}/blank`,
    kanban: `${ROOTS.DASHBOARD}/kanban`,
    calendar: `${ROOTS.DASHBOARD}/calendar`,
    fileManager: `${ROOTS.DASHBOARD}/file-manager`,
    permission: `${ROOTS.DASHBOARD}/permission`,
    general: {
      app: `${ROOTS.DASHBOARD}/app`,
      ecommerce: `${ROOTS.DASHBOARD}/ecommerce`,
      analytics: `${ROOTS.DASHBOARD}/analytics`,
      banking: `${ROOTS.DASHBOARD}/banking`,
      booking: `${ROOTS.DASHBOARD}/booking`,
      file: `${ROOTS.DASHBOARD}/file`,
    },
    user: {
      root: `${ROOTS.DASHBOARD}/user/edit`,
      edit: `${ROOTS.DASHBOARD}/user/edit`,
      twoFactor: `${ROOTS.DASHBOARD}/user/two-factor`,
      // edit: (id) => `${ROOTS.DASHBOARD}/user/${id}/edit`,

    },
    product: {
      root: `${ROOTS.DASHBOARD}/product`,
      new: `${ROOTS.DASHBOARD}/product/new`,
      details: (id) => `${ROOTS.DASHBOARD}/product/${id}`,
      edit: (id) => `${ROOTS.DASHBOARD}/product/${id}/edit`,
      demo: {
        details: `${ROOTS.DASHBOARD}/product/${MOCK_ID}`,
        edit: `${ROOTS.DASHBOARD}/product/${MOCK_ID}/edit`,
      },
    },
    invoice: {
      root: `${ROOTS.DASHBOARD}/invoice`,
      new: `${ROOTS.DASHBOARD}/invoice/new`,
      details: (id) => `${ROOTS.DASHBOARD}/invoice/${id}`,
      edit: (id) => `${ROOTS.DASHBOARD}/invoice/${id}/edit`,
      demo: {
        details: `${ROOTS.DASHBOARD}/invoice/${MOCK_ID}`,
        edit: `${ROOTS.DASHBOARD}/invoice/${MOCK_ID}/edit`,
      },
    },
    post: {
      root: `${ROOTS.DASHBOARD}/post`,
      new: `${ROOTS.DASHBOARD}/post/new`,
      details: (title) => `${ROOTS.DASHBOARD}/post/${paramCase(title)}`,
      edit: (title) => `${ROOTS.DASHBOARD}/post/${paramCase(title)}/edit`,
      demo: {
        details: `${ROOTS.DASHBOARD}/post/${paramCase(MOCK_TITLE)}`,
        edit: `${ROOTS.DASHBOARD}/post/${paramCase(MOCK_TITLE)}/edit`,
      },
    },

    storageManager: (site_code) => `${ROOTS.DASHBOARD}/site/${site_code}/storage-manager`,
    posts: {
      root: (site_code, post_type_id) => `${ROOTS.DASHBOARD}/site/${site_code}/posts/${post_type_id}`,
      list: (site_code, post_type_id) => `${ROOTS.DASHBOARD}/site/${site_code}/posts/${post_type_id}/list`,
      new: (site_code, post_type_id) => `${ROOTS.DASHBOARD}/site/${site_code}/posts/${post_type_id}/new`,
      edit: (site_code, post_type_id, id) => `${ROOTS.DASHBOARD}/site/${site_code}/posts/${post_type_id}/${id}/edit`,
      category: (site_code, post_type_id) => `${ROOTS.DASHBOARD}/site/${site_code}/posts/${post_type_id}/category/list`,
      category_new: (site_code, post_type_id) => `${ROOTS.DASHBOARD}/site/${site_code}/posts/${post_type_id}/category/new`,
      category_new_son: (site_code, post_type_id, id) => `${ROOTS.DASHBOARD}/site/${site_code}/posts/${post_type_id}/category/${id}/new-son`,
      category_edit: (site_code, post_type_id, id) => `${ROOTS.DASHBOARD}/site/${site_code}/posts/${post_type_id}/category/${id}/edit`,
    },
    page: {
      root: (site_code) => `${ROOTS.DASHBOARD}/site/${site_code}/page`,
      edit: (site_code, id) => `${ROOTS.DASHBOARD}/site/${site_code}/page/${id}/edit`,
    },
    site: {
      root: (site_code) => `${ROOTS.DASHBOARD}/site/${site_code}`,
      edit: (site_code) => `${ROOTS.DASHBOARD}/site/${site_code}/edit`,
    },
    config: {
      root: (site_code) => `${ROOTS.DASHBOARD}/site/${site_code}/config/list`,
      site: (site_code, layout_name) => `${ROOTS.DASHBOARD}/site/${site_code}/config/site/${layout_name}`,
      site_layout: (site_code) => `${ROOTS.DASHBOARD}/site/${site_code}/config/site/layout`,
      site_layout_list: (site_code) => `${ROOTS.DASHBOARD}/site/${site_code}/config/site/layout/list`,
      site_preview: (site_code) => `${ROOTS.DASHBOARD}/site/${site_code}/config/site/preview-edit`,
      posts_order: (site_code) => `${ROOTS.DASHBOARD}/site/${site_code}/config/posts-order`,
      page_order: (site_code) => `${ROOTS.DASHBOARD}/site/${site_code}/config/page-order`,
      post_type_order: (site_code) => `${ROOTS.DASHBOARD}/site/${site_code}/config/post-type-order`,

      post_layout: (site_code, post_type_id) => `${ROOTS.DASHBOARD}/site/${site_code}/config/post/${post_type_id}/layout`,
      post_layout_list: (site_code, post_type_id) => `${ROOTS.DASHBOARD}/site/${site_code}/config/post/${post_type_id}/layout/list`,
      post_preview: (site_code, post_type_id) => `${ROOTS.DASHBOARD}/site/${site_code}/config/post/${post_type_id}/preview-edit`,
      post_edit_preview: (site_code, post_type_id) => `${ROOTS.DASHBOARD}/site/${site_code}/config/post/${post_type_id}/edit-preview`,
      post_summary: (site_code, post_type_id) => `${ROOTS.DASHBOARD}/site/${site_code}/config/post/${post_type_id}/summary-edit`,
      post: (site_code, post_type_id, layout_name) => `${ROOTS.DASHBOARD}/site/${site_code}/config/post/${post_type_id}/${layout_name}`,

      post_category: (site_code, post_type_id, layout_name) => `${ROOTS.DASHBOARD}/site/${site_code}/config/post-category/${post_type_id}/${layout_name}`,
      post_category_layout: (site_code, post_type_id) => `${ROOTS.DASHBOARD}/site/${site_code}/config/post-category/${post_type_id}/layout`,
      post_category_layout_list: (site_code, post_type_id) => `${ROOTS.DASHBOARD}/site/${site_code}/config/post-category/${post_type_id}/layout/list`,
      post_category_preview: (site_code, post_type_id) => `${ROOTS.DASHBOARD}/site/${site_code}/config/post-category/${post_type_id}/preview-edit`,

      page: (site_code, page_pkg_code, page_id, layout_name) => `${ROOTS.DASHBOARD}/site/${site_code}/config/page/${page_pkg_code}/${page_id}/${layout_name}`,
      page_layout: (site_code, page_pkg_code, page_id) => `${ROOTS.DASHBOARD}/site/${site_code}/config/page/${page_pkg_code}/${page_id}/layout`,
      page_layout_list: (site_code, page_pkg_code, page_id) => `${ROOTS.DASHBOARD}/site/${site_code}/config/page/${page_pkg_code}/${page_id}/layout/list`,
      page_preview: (site_code, page_pkg_code, page_id) => `${ROOTS.DASHBOARD}/site/${site_code}/config/page/${page_pkg_code}/${page_id}/preview-edit`,
      post_type: (site_code, post_type_id, layout_name) => `${ROOTS.DASHBOARD}/site/${site_code}/config/post-type/${post_type_id}/${layout_name}`,
      post_type_layout: (site_code, post_type_id) => `${ROOTS.DASHBOARD}/site/${site_code}/config/post-type/${post_type_id}/layout`,
      post_type_layout_list: (site_code, post_type_id) => `${ROOTS.DASHBOARD}/site/${site_code}/config/post-type/${post_type_id}/layout/list`,
      post_type_preview: (site_code, post_type_id) => `${ROOTS.DASHBOARD}/site/${site_code}/config/post-type/${post_type_id}/preview-edit`,

      post_type_add: (site_code) => `${ROOTS.DASHBOARD}/site/${site_code}/config/post-type-add`,
      page_add: (site_code) => `${ROOTS.DASHBOARD}/site/${site_code}/config/page-add`,
      page_post_add: (site_code) => `${ROOTS.DASHBOARD}/site/${site_code}/config/page-post-add`,
      ai_settings: (site_code) => `${ROOTS.DASHBOARD}/site/${site_code}/config/ai-settings`,
    },
    v2: {
      api_config: (site_code) => `${ROOTS.DASHBOARD}/site/${site_code}/v2/api-config`,
      edit: (site_code) => `${ROOTS.DASHBOARD}/site/${site_code}/v2/edit`,
      site_preview: (site_code) => `${ROOTS.DASHBOARD}/site/${site_code}/v2/site/preview-edit`,
      site_layout_list: (site_code) => `${ROOTS.DASHBOARD}/site/${site_code}/v2/site/layout/list`,
      site_layout: (site_code) => `${ROOTS.DASHBOARD}/site/${site_code}/v2/site/layout`,
      site: (site_code, layout_name) => `${ROOTS.DASHBOARD}/site/${site_code}/v2/site/${layout_name}`,
      ai_settings: (site_code) => `${ROOTS.DASHBOARD}/site/${site_code}/v2/ai-settings`,
      theme_list: (site_code) => `${ROOTS.DASHBOARD}/site/${site_code}/v2/theme-list`,
      theme_new: (site_code) => `${ROOTS.DASHBOARD}/site/${site_code}/v2/theme/new`,
      theme_edit: (site_code, theme_code) => `${ROOTS.DASHBOARD}/site/${site_code}/v2/theme/${theme_code}/edit`,
      template_pkg_list: (site_code) => `${ROOTS.DASHBOARD}/site/${site_code}/v2/template-pkg-list`,
      template_pkg_new: (site_code) => `${ROOTS.DASHBOARD}/site/${site_code}/v2/template-pkg/new`,
      template_pkg_edit: (site_code, code) => `${ROOTS.DASHBOARD}/site/${site_code}/v2/template-pkg/${code}/edit`,
      page_pkg_list: (site_code) => `${ROOTS.DASHBOARD}/site/${site_code}/v2/page-pkg-list`,
      page_pkg_new: (site_code) => `${ROOTS.DASHBOARD}/site/${site_code}/v2/page-pkg/new`,
      page_pkg_edit: (site_code, code) => `${ROOTS.DASHBOARD}/site/${site_code}/v2/page-pkg/${code}/edit`,
      post_type_add: (site_code) => `${ROOTS.DASHBOARD}/site/${site_code}/v2/post-type-add`,
      page_add: (site_code) => `${ROOTS.DASHBOARD}/site/${site_code}/v2/page-add`,
      page_post_add: (site_code) => `${ROOTS.DASHBOARD}/site/${site_code}/v2/page-post-add`,
      post_type_list: (site_code) => `${ROOTS.DASHBOARD}/site/${site_code}/v2/post-type-list`,
      post_type_layout_list: (site_code, post_type_id) => `${ROOTS.DASHBOARD}/site/${site_code}/v2/post-type/${post_type_id}/layout/list`,
      post_type_layout: (site_code, post_type_id) => `${ROOTS.DASHBOARD}/site/${site_code}/v2/post-type/${post_type_id}/layout`,
      post_type: (site_code, post_type_id, layout_name) => `${ROOTS.DASHBOARD}/site/${site_code}/v2/post-type/${post_type_id}/${layout_name}`,
      post_type_preview: (site_code, post_type_id) => `${ROOTS.DASHBOARD}/site/${site_code}/v2/post-type/${post_type_id}/preview-edit`,
      post_type_edit: (site_code, post_type_id) => `${ROOTS.DASHBOARD}/site/${site_code}/v2/post-type/${post_type_id}/edit`,
      // POST 項目設定
      post_config_list: (site_code) => `${ROOTS.DASHBOARD}/site/${site_code}/v2/post-config-list`,
      post_layout_list: (site_code, post_type_id) => `${ROOTS.DASHBOARD}/site/${site_code}/v2/post/${post_type_id}/layout/list`,
      post_layout: (site_code, post_type_id) => `${ROOTS.DASHBOARD}/site/${site_code}/v2/post/${post_type_id}/layout`,
      post_item: (site_code, post_type_id, layout_name) => `${ROOTS.DASHBOARD}/site/${site_code}/v2/post/${post_type_id}/${layout_name}`,
      post_config_preview: (site_code, post_type_id) => `${ROOTS.DASHBOARD}/site/${site_code}/v2/post/${post_type_id}/preview-edit`,
      post_edit_preview: (site_code, post_type_id) => `${ROOTS.DASHBOARD}/site/${site_code}/v2/post/${post_type_id}/edit-preview`,
      post_summary_edit: (site_code, post_type_id) => `${ROOTS.DASHBOARD}/site/${site_code}/v2/post/${post_type_id}/summary-edit`,
      // POST CATEGORY 項目設定
      post_category_config_list: (site_code) => `${ROOTS.DASHBOARD}/site/${site_code}/v2/post-category-config-list`,
      post_category_layout_list: (site_code, post_type_id) => `${ROOTS.DASHBOARD}/site/${site_code}/v2/post-category/${post_type_id}/layout/list`,
      post_category_layout: (site_code, post_type_id) => `${ROOTS.DASHBOARD}/site/${site_code}/v2/post-category/${post_type_id}/layout`,
      post_category_item: (site_code, post_type_id, layout_name) => `${ROOTS.DASHBOARD}/site/${site_code}/v2/post-category/${post_type_id}/${layout_name}`,
      post_category_config_preview: (site_code, post_type_id) => `${ROOTS.DASHBOARD}/site/${site_code}/v2/post-category/${post_type_id}/preview-edit`,
      // Theme Template 管理（α版）
      theme_template_list: (site_code, theme_code) => `${ROOTS.DASHBOARD}/site/${site_code}/v2/theme/${theme_code}/template/list`,
      theme_template_new: (site_code, theme_code) => `${ROOTS.DASHBOARD}/site/${site_code}/v2/theme/${theme_code}/template/new`,
      theme_template_edit: (site_code, theme_code, tpl_code) => `${ROOTS.DASHBOARD}/site/${site_code}/v2/theme/${theme_code}/template/${tpl_code}/edit`,
      theme_layout_list: (site_code, theme_code) => `${ROOTS.DASHBOARD}/site/${site_code}/v2/theme/${theme_code}/layout/list`,
      theme_layout_new: (site_code, theme_code) => `${ROOTS.DASHBOARD}/site/${site_code}/v2/theme/${theme_code}/layout/new`,
      theme_layout_edit: (site_code, theme_code, layout_code) => `${ROOTS.DASHBOARD}/site/${site_code}/v2/theme/${theme_code}/layout/${layout_code}/edit`,
      theme_block_list: (site_code, theme_code) => `${ROOTS.DASHBOARD}/site/${site_code}/v2/theme/${theme_code}/block/list`,
      theme_block_new: (site_code, theme_code) => `${ROOTS.DASHBOARD}/site/${site_code}/v2/theme/${theme_code}/block/new`,
      theme_block_edit: (site_code, theme_code, block_code) => `${ROOTS.DASHBOARD}/site/${site_code}/v2/theme/${theme_code}/block/${block_code}/edit`,
      // Theme Page 管理
      theme_page_list: (site_code, theme_code) => `${ROOTS.DASHBOARD}/site/${site_code}/v2/theme/${theme_code}/page/list`,
      theme_page_layout_list: (site_code, theme_code, page_id) => `${ROOTS.DASHBOARD}/site/${site_code}/v2/theme/${theme_code}/page/${page_id}/layout/list`,
      theme_page_layout: (site_code, theme_code, page_id) => `${ROOTS.DASHBOARD}/site/${site_code}/v2/theme/${theme_code}/page/${page_id}/layout`,
      theme_page_item: (site_code, theme_code, page_id, name) => `${ROOTS.DASHBOARD}/site/${site_code}/v2/theme/${theme_code}/page/${page_id}/${name}`,
      theme_page_preview: (site_code, theme_code, page_id) => `${ROOTS.DASHBOARD}/site/${site_code}/v2/theme/${theme_code}/page/${page_id}/preview-edit`,
      theme_page_add: (site_code, theme_code) => `${ROOTS.DASHBOARD}/site/${site_code}/v2/theme/${theme_code}/page/add`,
      theme_page_post_add: (site_code, theme_code) => `${ROOTS.DASHBOARD}/site/${site_code}/v2/theme/${theme_code}/page/post-add`,
      theme_page_edit: (site_code, theme_code, page_id) => `${ROOTS.DASHBOARD}/site/${site_code}/v2/theme/${theme_code}/page/${page_id}/edit`,
      // Theme Design Editor (Web IDE)
      theme_design_editor: (site_code, theme_code) => `${ROOTS.DASHBOARD}/site/${site_code}/v2/theme/${theme_code}/design-editor`,
      // フォーム管理
      form: {
        root: (site_code) => `${ROOTS.DASHBOARD}/site/${site_code}/v2/form`,
        new: (site_code) => `${ROOTS.DASHBOARD}/site/${site_code}/v2/form/new`,
        edit: (site_code, form_id) => `${ROOTS.DASHBOARD}/site/${site_code}/v2/form/${form_id}/edit`,
        items: (site_code, form_id) => `${ROOTS.DASHBOARD}/site/${site_code}/v2/form/${form_id}/items`,
        mail: (site_code, form_id) => `${ROOTS.DASHBOARD}/site/${site_code}/v2/form/${form_id}/mail`,
        data: (site_code, form_id) => `${ROOTS.DASHBOARD}/site/${site_code}/v2/form/${form_id}/data`,
        error_message: (site_code) => `${ROOTS.DASHBOARD}/site/${site_code}/v2/form/error-message`,
      },
      // サイト環境設定（Digest認証・SMTP・Shopify・reCAPTCHA）
      site_config: (site_code) => `${ROOTS.DASHBOARD}/site/${site_code}/v2/site-config`,
    },
    post_type: {
      root: (site_code) => `${ROOTS.DASHBOARD}/site/${site_code}/post-type`,
      edit: (site_code, id) => `${ROOTS.DASHBOARD}/site/${site_code}/post-type/${id}/edit`,
    },


    order: {
      root: `${ROOTS.DASHBOARD}/order`,
      details: (id) => `${ROOTS.DASHBOARD}/order/${id}`,
      demo: {
        details: `${ROOTS.DASHBOARD}/order/${MOCK_ID}`,
      },
    },
    job: {
      root: `${ROOTS.DASHBOARD}/job`,
      new: `${ROOTS.DASHBOARD}/job/new`,
      details: (id) => `${ROOTS.DASHBOARD}/job/${id}`,
      edit: (id) => `${ROOTS.DASHBOARD}/job/${id}/edit`,
      demo: {
        details: `${ROOTS.DASHBOARD}/job/${MOCK_ID}`,
        edit: `${ROOTS.DASHBOARD}/job/${MOCK_ID}/edit`,
      },
    },
    tour: {
      root: `${ROOTS.DASHBOARD}/tour`,
      new: `${ROOTS.DASHBOARD}/tour/new`,
      details: (id) => `${ROOTS.DASHBOARD}/tour/${id}`,
      edit: (id) => `${ROOTS.DASHBOARD}/tour/${id}/edit`,
      demo: {
        details: `${ROOTS.DASHBOARD}/tour/${MOCK_ID}`,
        edit: `${ROOTS.DASHBOARD}/tour/${MOCK_ID}/edit`,
      },
    },
    customer_log: {
      root: (site_code) => `${ROOTS.DASHBOARD}/site/${site_code}/customer-log`,
    },
    qa_generation: {
      root: (site_code) => `${ROOTS.DASHBOARD}/site/${site_code}/qa-generation`,
    },
    qa_generation_task: {
      root: (site_code) => `${ROOTS.DASHBOARD}/site/${site_code}/qa-generation-task`,
      details: (site_code, taskId) => `${ROOTS.DASHBOARD}/site/${site_code}/qa-generation-task/${taskId}`,
    },
    template: {
      root: (site_code) => `${ROOTS.DASHBOARD}/site/${site_code}/template`,
      list: (site_code) => `${ROOTS.DASHBOARD}/site/${site_code}/template/list`,
      new: (site_code) => `${ROOTS.DASHBOARD}/site/${site_code}/template/new`,
      edit: (site_code, tpl_code) => `${ROOTS.DASHBOARD}/site/${site_code}/template/${tpl_code}/edit`,
      layout_list: (site_code) => `${ROOTS.DASHBOARD}/site/${site_code}/template/layout/list`,
      layout_new: (site_code) => `${ROOTS.DASHBOARD}/site/${site_code}/template/layout/new`,
      layout_edit: (site_code, layout_code) => `${ROOTS.DASHBOARD}/site/${site_code}/template/layout/${layout_code}/edit`,
      block_list: (site_code) => `${ROOTS.DASHBOARD}/site/${site_code}/template/block/list`,
      block_new: (site_code) => `${ROOTS.DASHBOARD}/site/${site_code}/template/block/new`,
      block_edit: (site_code, block_code) => `${ROOTS.DASHBOARD}/site/${site_code}/template/block/${block_code}/edit`,
    },
  },
};
